// 플레이오토 2.0 솔루션과 API 의 연동 선행 조건·동작 구조를 안내하는 이용가이드 페이지
import styled from 'styled-components';
import SimpleSideNav from '../../layout/SideNav/SimpleSideNav';
import { GuideContentList } from '../../../store/LeftContentList';

const FlowPage = () => {
  return (
    <>
      <SimpleSideNav data={GuideContentList} />
      <Container>
        <h2>연동 흐름</h2>

        <section>
          <h3>연동 준비 흐름</h3>
          <div>
            <p>
              플레이오토 2.0 API 는 솔루션과 짝을 이루어 동작합니다. 그래서 API Key 만 발급받으면 바로 호출할 수 있는 구조가 아니고,
              준비 작업이 개발자센터와 플레이오토 2.0 솔루션 두 곳에 나뉘어 있습니다.<br/>
              아래 순서대로 준비하면 첫 호출까지 도달합니다. 앞 단계가 끝나지 않으면 다음 단계가 진행되지 않습니다.
            </p>

            <FlowDiagram>
              <div className='flow__legend'>
                <span className='flow__legend-item'>
                  <Actor $type='solution'>플레이오토 2.0 솔루션</Actor> 솔루션에 접속해서 하는 일
                </span>
                <span className='flow__legend-item'>
                  <Actor $type='devcenter'>개발자센터</Actor> 이 사이트에서 하는 일
                </span>
                <span className='flow__legend-item'>
                  <Actor $type='api'>API 호출</Actor> 코드로 하는 일
                </span>
              </div>

              <div className='flow__step'>
                <div className='flow__num'>1</div>
                <div className='flow__where'><Actor $type='solution'>플레이오토 2.0 솔루션</Actor></div>
                <div className='flow__body'>
                  <div className='flow__title'>사용 중인 플레이오토 2.0 솔루션 확인</div>
                  <div className='flow__desc'>
                    API 는 솔루션에 쌓인 데이터를 다루는 수단입니다. 연동할 솔루션 계정이 먼저 있어야 합니다.
                  </div>
                  <div className='flow__gate'>이용 기간이 만료된 솔루션으로는 인증 토큰이 발급되지 않습니다.</div>
                </div>
              </div>

              <div className='flow__step'>
                <div className='flow__num'>2</div>
                <div className='flow__where'><Actor $type='devcenter'>개발자센터</Actor></div>
                <div className='flow__body'>
                  <div className='flow__title'>사용신청 후 API Key 발급</div>
                  <div className='flow__desc'>
                    개발자센터에서 사용신청을 하고 승인을 받으면 API Key 가 발급됩니다. 이 키가 누가 호출하는지를 나타냅니다.
                  </div>
                  <div className='flow__gate'>발급 절차와 승인 기준은 "시작하기" 페이지에서 확인할 수 있습니다.</div>
                </div>
              </div>

              <div className='flow__step'>
                <div className='flow__num'>3</div>
                <div className='flow__where'><Actor $type='solution'>플레이오토 2.0 솔루션</Actor></div>
                <div className='flow__body'>
                  <div className='flow__title'>API 연동 부가서비스 결제</div>
                  <div className='flow__desc'>
                    API 연동은 부가서비스입니다. 솔루션에서 결제해야 API 호출이 허용됩니다.
                  </div>
                  <div className='flow__gate'>요금과 사용 조건은 "소개" 페이지에서 확인할 수 있습니다.</div>
                </div>
              </div>

              <div className='flow__step'>
                <div className='flow__num'>4</div>
                <div className='flow__where'><Actor $type='solution'>플레이오토 2.0 솔루션</Actor></div>
                <div className='flow__body'>
                  <div className='flow__title'>연동할 쇼핑몰 계정 등록</div>
                  <div className='flow__desc'>
                    쿠팡 주문을 수집하려면 솔루션에 쿠팡 계정이 등록되어 있어야 합니다.
                    등록되지 않은 쇼핑몰은 API 로도 다룰 수 없습니다.
                  </div>
                  <div className='flow__gate'>이 단계를 건너뛰면 호출은 성공하지만 가져올 데이터가 없습니다.</div>
                </div>
              </div>

              <div className='flow__step'>
                <div className='flow__num'>5</div>
                <div className='flow__where'><Actor $type='api'>API 호출</Actor></div>
                <div className='flow__body'>
                  <div className='flow__title'>인증 토큰 발급</div>
                  <div className='flow__desc'>
                    API Key 와 연동할 솔루션의 인증 정보로 토큰을 발급받습니다.
                    토큰이 어느 솔루션의 데이터를 다루는지를 결정합니다.
                  </div>
                </div>
              </div>

              <div className='flow__step'>
                <div className='flow__num'>6</div>
                <div className='flow__where'><Actor $type='api'>API 호출</Actor></div>
                <div className='flow__body'>
                  <div className='flow__title'>API 호출</div>
                  <div className='flow__desc'>
                    API Key 와 토큰을 함께 담아 호출합니다. 여기서부터 상품·주문·재고 API 를 사용할 수 있습니다.
                  </div>
                </div>
              </div>
            </FlowDiagram>

            <dl>
              <dt>키와 토큰의 역할이 다릅니다</dt>
              <dd>
                API Key 는 호출하는 주체를, 인증 토큰은 다룰 솔루션을 가리킵니다.
                그래서 한 API Key 로 여러 솔루션을 연동하는 경우 솔루션별로 토큰을 따로 발급받습니다.
              </dd>
            </dl>
          </div>
        </section>

        <section>
          <h3>쇼핑몰 계정이 데이터 범위를 결정합니다</h3>
          <div>
            <p>
              API 가 다루는 데이터는 솔루션에 등록된 쇼핑몰 계정의 범위를 벗어나지 않습니다.
              API 는 쇼핑몰에 직접 접속하지 않고, 솔루션이 등록된 계정으로 쇼핑몰과 통신한 결과를 다룹니다.
            </p>

            <ScopeCompare>
              <div className='scope__card'>
                <div className='scope__head scope__head--ok'>솔루션에 쿠팡 계정이 등록된 경우</div>
                <div className='scope__body'>
                  주문수집 작업을 등록하면 솔루션이 그 계정으로 쿠팡 주문을 가져옵니다.<br/>
                  이후 주문 조회 API 로 수집된 주문을 확인할 수 있습니다.
                </div>
              </div>
              <div className='scope__card'>
                <div className='scope__head scope__head--no'>등록되지 않은 경우</div>
                <div className='scope__body'>
                  호출 자체는 실패하지 않지만 대상 계정이 없어 수집되는 주문도 없습니다.<br/>
                  주문이 들어오지 않는다는 문의의 가장 흔한 원인입니다.
                </div>
              </div>
            </ScopeCompare>

          </div>
        </section>

        <section>
          <h3>쇼핑몰과의 통신은 작업으로 처리됩니다</h3>
          <div>
            <p>
              API 는 두 가지 성격으로 나뉩니다. 솔루션 데이터를 읽고 쓰는 것과 쇼핑몰과 실제로 통신하는 것입니다.
              뒤쪽은 즉시 처리되지 않고 작업으로 등록됩니다.
            </p>

            <ArchDiagram>
              <div className='arch__col'>
                <div className='arch__col-head'>내 서버</div>
                <div className='arch__col-sub'>API 를 호출하는 쪽</div>
                <div className='arch__box'>API Key + 인증 토큰으로 호출</div>
              </div>
              <div className='arch__arrow'>
                <span>⇆</span>
                즉시 응답
              </div>
              <div className='arch__col arch__col--center'>
                <div className='arch__col-head'>플레이오토 2.0 솔루션</div>
                <div className='arch__col-sub'>데이터를 보관하고 쇼핑몰과 통신하는 쪽</div>
                <div className='arch__box'>조회·등록 API 는 여기 데이터를 다룹니다</div>
                <div className='arch__box'>작업 API 는 여기에 작업을 등록합니다</div>
              </div>
              <div className='arch__arrow'>
                <span>⇆</span>
                작업 실행 시
              </div>
              <div className='arch__col'>
                <div className='arch__col-head'>쇼핑몰</div>
                <div className='arch__col-sub'>쿠팡 · 스마트스토어 등</div>
                <div className='arch__box'>솔루션이 등록된 계정으로 통신</div>
              </div>
            </ArchDiagram>

            <p>
              내 서버는 쇼핑몰과 직접 통신하지 않습니다. 주문수집이나 운송장 전송처럼 쇼핑몰이 관여하는 기능은
              작업을 등록해 솔루션이 대신 처리하게 하고, 그 결과를 조회 API 로 확인합니다.
            </p>

            <CompareTable>
              <tbody>
                <tr>
                  <th>조회 · 등록 API</th>
                  <td>
                    솔루션에 보관된 데이터를 다룹니다. 호출하면 결과가 바로 돌아옵니다.<br/>
                    주문 목록 조회, 상품 등록, 재고 수정이 여기 해당합니다.
                  </td>
                </tr>
                <tr>
                  <th>작업 API</th>
                  <td>
                    쇼핑몰과 통신해야 하는 기능입니다. 호출하면 작업이 등록되고 작업 번호가 돌아옵니다.
                    결과는 작업이 끝난 뒤 조회해야 확인할 수 있습니다.<br/>
                    주문수집, 상품 전송, 운송장 전송이 여기 해당합니다.
                  </td>
                </tr>
              </tbody>
            </CompareTable>

            <h4>작업 API 를 쓰는 순서</h4>

            <SeqSteps>
              <div className='seq__item'>
                <div className='seq__step'>STEP 1</div>
                <div className='seq__title'>작업 등록</div>
                <div className='seq__desc'>수집·전송할 대상과 작업 종류를 지정해 호출합니다.</div>
              </div>
              <div className='seq__item'>
                <div className='seq__step'>STEP 2</div>
                <div className='seq__title'>작업 번호 수신</div>
                <div className='seq__desc'>
                  응답으로 <span className='seq__code'>work_no</span> 가 돌아옵니다.
                  이 시점에는 아직 작업이 끝나지 않았습니다.
                </div>
              </div>
              <div className='seq__item'>
                <div className='seq__step'>STEP 3</div>
                <div className='seq__title'>작업 상태 조회</div>
                <div className='seq__desc'>작업 번호로 진행 상태를 확인합니다. 완료·실패와 메시지를 받습니다.</div>
              </div>
              <div className='seq__item'>
                <div className='seq__step'>STEP 4</div>
                <div className='seq__title'>데이터 조회</div>
                <div className='seq__desc'>작업이 완료된 후 조회 API 로 결과를 가져옵니다.</div>
              </div>
            </SeqSteps>

            <dl>
              <dt>주문 조회 API 를 불렀는데 새 주문이 없다면</dt>
              <dd>
                주문 조회 API 는 솔루션에 이미 수집된 주문을 보여줍니다.
                쇼핑몰의 새 주문을 가져오려면 먼저 주문수집 작업을 등록해야 합니다.
                작업이 완료되기 전에 조회하면 수집 전 상태가 그대로 보입니다.
              </dd>
              <dt>작업 실행에는 작업카운트가 차감됩니다</dt>
              <dd>
                상품 전송이나 주문수집 같은 작업은 솔루션의 작업카운트를 사용합니다.
                카운트가 부족하면 작업이 진행되지 않습니다.
              </dd>
            </dl>
          </div>
        </section>

        <section>
          <h3>화면에서만 할 수 있는 설정이 있습니다</h3>
          <div>
            <p>
              솔루션의 모든 기능이 API 로 제공되지는 않습니다. 선택 화면이 필요한 항목은 솔루션에서 먼저 설정해 두고,
              API 는 그렇게 만들어 둔 설정을 참조합니다.
            </p>

            <dl>
              <dt>쇼핑몰 카테고리 · 상품 템플릿</dt>
              <dd>
                쇼핑몰마다 분류 체계와 필수 항목이 달라 화면에서 선택해야 합니다.
                솔루션에서 미리 만들어 두면 상품 등록 API 에서 그 값을 지정해 사용할 수 있습니다.
              </dd>
              <dt>연동 대상 설정</dt>
              <dd>
                쇼핑몰 계정 등록과 대행사 연동 설정은 솔루션에서 처리합니다. API 로 변경할 수 없습니다.
              </dd>
            </dl>

            <p>
              그래서 플레이오토 2.0 을 처음 쓴다면 API 개발 전에 솔루션에 접속해
              연동 대상과 기본 설정을 먼저 준비하는 편이 빠릅니다.
            </p>
          </div>
        </section>
      </Container>
    </>
  );
};

/**
 * 페이지 본문 래퍼.
 * 형제 가이드 페이지(OverviewPage·InstructionPage)와 값을 맞춘다. 디자인 토큰으로 바꾸지 않는 이유는
 * --color-text-muted(#626c77)·--color-border(#e3e6ea)가 아래 #666·#ddd 와 값이 달라
 * 같은 사이드 내비를 공유하는 페이지 사이에 색이 어긋나기 때문이다.
 * 이 페이지에서 새로 만드는 요소(다이어그램·카드·배지)는 토큰을 쓴다.
 */
const Container = styled.div`
  width: 100%;
  padding: 110px 100px;

  > h2 {
    font-size: 36px;
    font-weight: bold;
  }

  > section {
    padding: 50px 0;
    border-bottom: 1px solid #ddd;
    &:last-child {
      border-bottom: none;
    }

    > h3 {
      font-size: 24px;
      font-weight: bold;
      margin-bottom: 20px
    }

    > div {

      > p {
        color: #666;
        font-size: 16px;
        line-height: 1.8;
      }

      /* dl > dt 와 같은 모양의 소제목. dd 가 따라오지 않는 자리에 쓴다.
         dt 만 있는 dl 은 스크린리더가 정의 없는 용어로 읽는다 */
      > h4 {
        margin: 20px 0 10px;
        font-size: 18px;
        font-weight: bold;

        &:before {
          content: "•";
          display: inline-block;
          width: 10px;
        }
      }

      > dl {
        > dt {
          font-weight: bold;
          font-size: 18px;
          margin: 20px 0 10px;
          &:before {
            content: "•";
            display: inline-block;
            width: 10px;
          }
        }
        > dd {
          color: #666;
          font-size: 16px;
          padding-left: 10px;
          line-height: 1.8;
        }
      }
    }
  }
`;

/* API 호출 배지의 녹색만 토큰이 없어 값을 직접 쓴다.
   --color-get(#8dbf42)이 녹색이지만 HTTP 메서드 배지 전용이라 의미가 달라 참조하지 않았고,
   이 페이지 한 곳에서만 쓰는 색을 전역 토큰으로 올리면 다른 화면이 의미를 오해해 참조하게 된다. */
const ACTOR_COLORS = {
  solution: `
    background: var(--color-surface-group);
    color: var(--color-text-muted);
    border: 1px solid var(--color-border-strong);
  `,
  devcenter: `
    background: var(--color-selected);
    color: var(--plto-theme);
    border: 1px solid #b8dcf7;
  `,
  api: `
    background: #eef7e9;
    color: #5c8f2e;
    border: 1px solid #cfe5bd;
  `,
};

/**
 * 준비 단계를 수행하는 주체를 나타내는 pill 배지.
 * $type 은 'solution' | 'devcenter' | 'api'.
 */
const Actor = styled.span`
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 var(--space-2);
  border-radius: var(--radius-pill);
  font-size: 12px;
  font-weight: bold;
  white-space: nowrap;

  ${({ $type }) => ACTOR_COLORS[$type]}
`;

/**
 * 연동 준비 6단계를 세로로 잇는 다이어그램.
 * 스텝 사이 연결선은 flow__step 의 :after 로 그리므로 flow__step 에 position: relative 가 필요하다.
 */
const FlowDiagram = styled.div`
  margin: var(--space-6) 0 var(--space-5);

  .flow__legend {
    display: flex;
    flex-wrap: wrap;
    gap: var(--space-4);
    margin-bottom: var(--space-5);
  }

  .flow__legend-item {
    display: flex;
    align-items: center;
    gap: var(--space-2);
    font-size: 13px;
    color: var(--color-text-muted);
  }

  .flow__step {
    position: relative;
    display: grid;
    grid-template-columns: 32px 150px 1fr;
    align-items: start;
    gap: var(--space-4);
    padding: var(--space-4);
    border: 1px solid var(--color-border);
    border-radius: var(--radius-lg);
    background: var(--color-surface);
  }

  .flow__step + .flow__step {
    margin-top: var(--space-5);
  }

  .flow__step:not(:last-child):after {
    content: '';
    position: absolute;
    left: 32px;
    bottom: calc(-1 * var(--space-5));
    width: 2px;
    height: var(--space-5);
    background: var(--color-border-strong);
  }

  .flow__num {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: var(--plto-theme);
    color: #fff;
    font-size: 14px;
    font-weight: bold;
  }

  .flow__where,
  .flow__body {
    padding-top: var(--space-1);
  }

  .flow__title {
    margin-bottom: var(--space-2);
    font-size: 16px;
    font-weight: bold;
    color: var(--color-text);
  }

  .flow__desc {
    font-size: 14px;
    line-height: 1.7;
    color: var(--color-text-muted);
  }

  .flow__gate {
    display: inline-block;
    margin-top: var(--space-2);
    padding: var(--space-1) var(--space-2);
    background: var(--color-surface-alt);
    border-left: 3px solid var(--plto-theme);
    font-size: 13px;
    color: var(--color-text-muted);
  }
`;

/**
 * 쇼핑몰 계정 등록 여부를 좌우로 대비하는 카드 2칸.
 * 카드 테두리·반경은 FlowDiagram 의 스텝 카드와 같은 값을 쓴다.
 */
const ScopeCompare = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-4);
  margin: var(--space-5) 0;

  .scope__card {
    border: 1px solid var(--color-border);
    border-radius: var(--radius-lg);
    /* 헤더 배경이 카드 모서리를 덮으므로 잘라낸다. 없으면 헤더 귀퉁이가 사각으로 튀어나온다 */
    overflow: hidden;
  }

  .scope__head {
    padding: var(--space-3) var(--space-4);
    font-size: 14px;
    font-weight: bold;
  }

  /* 등록된 경우의 녹색. Actor api 배지와 같은 계열이지만 14px 헤더라 글씨색을 더 어둡게 쓴다.
     토큰에 대응 값이 없어 값을 직접 쓴다 (ACTOR_COLORS 주석과 같은 이유) */
  .scope__head--ok {
    background: #eef7e9;
    color: #4a7a24;
  }

  .scope__head--no {
    background: var(--color-surface-alt);
    color: var(--color-text-subtle);
  }

  .scope__body {
    padding: var(--space-4);
    font-size: 13px;
    line-height: 1.8;
    color: var(--color-text-muted);
  }
`;

/**
 * 내 서버 · 솔루션 · 쇼핑몰 3영역과 그 사이 통신을 나타내는 구조도.
 * 가운데 열(솔루션)에만 배경을 줘서 중계자임을 드러낸다.
 */
const ArchDiagram = styled.div`
  display: grid;
  /* 화살표 열을 고정폭으로 두지 않는다. 40px 로 두면 12px 설명 텍스트가 3자에서 끊겨
     화살표 아래가 두 줄이 되고 묶음의 시각적 중심이 카드 중앙에서 밀린다 */
  grid-template-columns: 1fr auto 1fr auto 1fr;
  align-items: stretch;
  margin: var(--space-6) 0 var(--space-5);

  .arch__col {
    padding: var(--space-4);
    border: 1px solid var(--color-border);
    border-radius: var(--radius-lg);
    background: var(--color-surface);
  }

  .arch__col--center {
    background: var(--color-surface-alt);
    border-color: var(--color-border-strong);
  }

  .arch__col-head {
    margin-bottom: var(--space-3);
    font-size: 15px;
    font-weight: bold;
  }

  .arch__col-sub {
    font-size: 13px;
    line-height: 1.6;
    color: var(--color-text-subtle);
  }

  .arch__box {
    margin-top: var(--space-3);
    padding: var(--space-3);
    border-radius: var(--radius-md);
    background: var(--color-surface-group);
    font-size: 13px;
    line-height: 1.6;
    color: var(--color-text-muted);
  }

  .arch__arrow {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: var(--space-1);
    padding: 0 var(--space-3);
    font-size: 12px;
    color: var(--color-text-subtle);
    white-space: nowrap;

    > span {
      font-size: 18px;
      color: var(--color-border-strong);
    }
  }
`;

/**
 * 조회·등록 API 와 작업 API 의 성격을 대비하는 2행 표.
 * DataTable.module.css 를 쓰지 않는다. 그쪽은 width 1180px 고정 · 가운데 정렬 · 고정 행높이의
 * 데이터 테이블용이라, 좌측 정렬 긴 설명을 담으려면 인라인 스타일로 거의 전부 덮어써야 한다.
 */
const CompareTable = styled.table`
  width: 100%;
  margin: var(--space-5) 0;
  border-collapse: collapse;
  font-size: 14px;

  th,
  td {
    padding: var(--space-3) var(--space-4);
    border: 1px solid var(--color-border);
    text-align: left;
    vertical-align: top;
    line-height: 1.7;
  }

  th {
    width: 22%;
    background: var(--color-surface-alt);
    font-weight: bold;
  }

  td {
    color: var(--color-text-muted);
  }
`;

/**
 * 작업 API 호출 순서 4단계.
 * work_no 같은 식별자는 code 태그 대신 span 에 클래스를 준다.
 * CDN Bootstrap 이 code 태그에 자체 색(#d63384)을 지정해 토큰과 무관한 분홍색이 나오기 때문이다.
 */
const SeqSteps = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: var(--space-3);
  margin: var(--space-5) 0;

  .seq__item {
    padding: var(--space-4);
    border: 1px solid var(--color-border);
    border-radius: var(--radius-md);
    background: var(--color-surface);
  }

  .seq__step {
    margin-bottom: var(--space-2);
    font-size: 12px;
    font-weight: bold;
    color: var(--plto-theme);
  }

  .seq__title {
    margin-bottom: var(--space-2);
    font-size: 14px;
    font-weight: bold;
  }

  .seq__desc {
    font-size: 13px;
    line-height: 1.6;
    color: var(--color-text-muted);
  }

  .seq__code {
    padding: 1px 5px;
    border-radius: var(--radius-sm);
    background: var(--color-surface-alt);
    font-family: var(--font-mono);
    font-size: 12px;
    color: var(--color-text-muted);
  }
`;

export default FlowPage;
